import styled from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const CategoryListWrapper = styled.div`
    border: 1px solid ${(props) => props.theme.color.g200};
    background: ${(props) => props.theme.color.g100};
    border-radius: 7px;
    padding: 20px;
    width: 100%;
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: block;
    }
`

export const CategoryTitle = styled.div`
    ${(props) => props.theme.typo.bodyS}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.black};
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: uppercase;
`

export const Category = styled(LinkBase)`
    display: flex;
    ${(props) => props.theme.typo.bodyM}
    color: ${(props) => props.theme.color.g600};
    text-decoration: none;
    margin-top: 20px;
    margin-bottom: 5px;

    &:hover {
        text-decoration: underline;
    }
`

export const ImageWrapper = styled.div`
    width: 18px;
    margin-right: 15px;
    height: 25px;
    display: flex;
    align-items: center;
`

export const CategoryListExpandableWrapper = styled.div<{ $open: boolean }>`
    border: 1px solid ${(props) => props.theme.color.g200};
    background: ${(props) => props.theme.color.g100};
    border-radius: 7px;
    padding: 17px 20px;
    width: 100%;
    height: 52px;
    margin-bottom: 50px;
    overflow: hidden;

    ${(props) => props.$open && 'height: auto;'}

    @media ${(props) => props.theme.query.min.tablet} {
        display: none;
    }
`
